.chatMessage {
    width: 100%;
    padding: 12px 16px;
    opacity: 0;
    animation: fadeIn 0.5s ease-in-out forwards;
}

.logoContainer {
    margin-right: 16px;
    flex-shrink: 0;
    align-self: flex-start;
}

.bubble {
    background-color: #e8f0fe;
    padding: 20px;
    border-radius: 10px;
    filter: drop-shadow(2px 2px 2px rgba(0, 0, 0, 0.2));
    max-width: 75%;
    margin-right: 48px;
    font-family: 'Hanken Grotesk', sans-serif;
    color: #323b48;
    flex-grow: 1;
}

.title {
    font-size: 16px;
    font-weight: 700;
    margin-bottom: 12px;
    color: #1f3559;
}

/* metadata table styles removed — metadata now lives inside turn ❶ header */

.sectionTitle {
    font-size: 14px;
    font-weight: 600;
    margin-bottom: 6px;
    color: #1f3559;
}

.timelineSection {
    margin-bottom: 12px;
}

.timelineTurn {
    background-color: rgba(255, 255, 255, 0.65);
    border-radius: 6px;
    margin-bottom: 8px;
    border: 1px solid #c7d7f0;
    overflow: hidden;
}

.timelineTurnHeader {
    background-color: rgba(199, 215, 240, 0.45);
    padding: 8px 10px;
    font-size: 12px;
    color: #1f3559;
    display: flex;
    align-items: flex-start;
    gap: 8px;
}

.turnIndex {
    background-color: #1f3559;
    color: white;
    font-weight: 700;
    font-size: 11px;
    width: 18px;
    height: 18px;
    border-radius: 50%;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    margin-top: 1px;
}

.turnHeaderText {
    flex-grow: 1;
    min-width: 0;
}

.turnTitle {
    font-size: 13px;
    font-weight: 600;
    color: #1f3559;
    word-break: break-word;
}

.turnSubtitle {
    font-size: 11px;
    color: #6b7280;
    margin-top: 2px;
}

.timelineTurnBody {
    padding: 10px 12px;
    font-size: 13px;
    line-height: 1.5;
    color: #323b48;

    ul,
    ol {
        padding-left: 20px;
        margin-bottom: 4px;
        margin-top: 4px;
    }
    li {
        margin-bottom: 4px;
    }
    p {
        margin-bottom: 6px;
    }
    strong,
    b {
        font-weight: 700;
    }
    code {
        font-size: 12px;
        background-color: rgba(255, 255, 255, 0.6);
        padding: 1px 4px;
        border-radius: 3px;
    }
}

.turnPending {
    color: #1f3559;
    font-style: italic;
    display: flex;
    align-items: center;
    gap: 6px;

    i {
        animation: spin 1.2s linear infinite;
    }
}

.turnEmpty {
    color: #6b7280;
    font-style: italic;
}

@keyframes spin {
    from {
        transform: rotate(0deg);
    }
    to {
        transform: rotate(360deg);
    }
}

.turnChangeLogContent {
    display: block;
}

.diffToggle {
    display: flex;
    align-items: center;
    gap: 6px;
    cursor: pointer;
    color: #1f3559;
    font-size: 13px;
    font-weight: 600;
    padding: 8px 0;
    user-select: none;

    &:hover {
        color: #2563eb;
    }

    i {
        font-size: 14px;
    }
}

.diffContainer {
    max-height: 400px;
    overflow-y: auto;
    overflow-x: auto;
    background-color: #fafafa;
    border: 1px solid #e5e7eb;
    border-radius: 6px;
    padding: 8px 0;
    font-family: 'Menlo', 'Consolas', monospace;
    font-size: 12px;
    line-height: 1.5;
    margin-top: 4px;
}

.lineSame,
.lineAdded,
.lineRemoved {
    display: flex;
    padding: 0 8px;
}

.lineSame {
    color: #57606a;
}

.lineAdded {
    background-color: #e6ffec;
    color: #1f883d;
}

.lineRemoved {
    background-color: #ffebe9;
    color: #cf222e;
}

.lineGap {
    display: flex;
    padding: 4px 8px;
    color: #8b949e;
    font-style: italic;
    background-color: #f6f8fa;
    border-top: 1px dashed #d0d7de;
    border-bottom: 1px dashed #d0d7de;
    font-size: 11px;
}

.gutter {
    width: 20px;
    text-align: center;
    flex-shrink: 0;
    user-select: none;
    color: #8b949e;
}

.lineText {
    white-space: pre-wrap;
    word-break: break-word;
    flex-grow: 1;
}

.discussSection {
    background-color: rgba(255, 255, 255, 0.7);
    border-radius: 6px;
    padding: 12px;
    margin-top: 12px;
    border: 1px solid #c7d7f0;
}

.discussLabel {
    font-size: 12px;
    color: #4a5568;
    margin-bottom: 8px;
    font-weight: 500;
}

.discussInput {
    width: 100%;
    min-height: 64px;
    max-height: 200px;
    border: 1px solid #c7d7f0;
    border-radius: 5px;
    padding: 8px 10px;
    font-family: 'Hanken Grotesk', sans-serif;
    font-size: 13px;
    line-height: 1.4;
    resize: vertical;
    color: #1f2937;
    background-color: white;

    &:focus {
        outline: none;
        border-color: #2563eb;
        box-shadow: 0 0 0 2px rgba(37, 99, 235, 0.15);
    }

    &:disabled {
        background-color: #f3f4f6;
        color: #6b7280;
    }
}

.citationChip {
    display: inline-block;
    margin: 0 2px;
    padding: 1px 6px;
    background-color: #eef2ff;
    border: 1px solid #c7d2fe;
    border-radius: 4px;
    color: #3730a3;
    font-size: 11px;
    line-height: 1.4;
    text-decoration: none;
    cursor: help;
    vertical-align: baseline;
    max-width: 180px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;

    &:hover {
        background-color: #e0e7ff;
        text-decoration: none;
    }
}
